"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBill = void 0;
/*global fetch:false*/
var baseUrl = 'https://insured-wbmi.firebaseio.com/';
var getBill = exports.getBill = function getBill(id) {
  return fetch(baseUrl + 'billing.json#' + id).then(function (res) {
    return res.json();
  });
};